import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TasksSettingsError() {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    includeSessionId: true,
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "CrmSettingsTaskReminders.errorMessage"
      })
    })
  });
}